import { FC, useState } from 'react';
import { useRange, UseRangeProps } from 'react-instantsearch';
import { useDebounce } from 'react-use';
import * as Slider from '@radix-ui/react-slider';
import { useDrawerFilterTracking } from '~/features/productList/hooks/useDrawerFilterTracking';
import styles from './RefinementSlider.module.scss';

export const RefinementSlider: FC<UseRangeProps> = (props: UseRangeProps) => {
    const { start, range, canRefine, refine } = useRange(props);
    const { min, max } = range as { min: number; max: number };
    const [value, setValue] = useState([min ?? 0, max ?? 100]);
    const { trackFilter } = useDrawerFilterTracking();
    const from = Math.max(min, Number.isFinite(start[0]) ? (start[0] as number) : min);
    const to = Math.min(max, Number.isFinite(start[1]) ? (start[1] as number) : max);

    const handleValueChange = (value: number[]) => {
        if (value[0] < value[1]) {
            setValue(value);
        }
    };

    const handleRefine = (value: number[]) => {
        trackFilter(
            'cust_effectivePrice',
            [value[0] ? value[0] : undefined, value[1] ? value[1] : undefined].toString(),
            { replace: true },
        );
        refine([value[0] ? value[0] : undefined, value[1] ? value[1] : undefined]);
    };

    useDebounce(
        () => {
            setValue([from, to]);
        },
        500,
        [from, to],
    );

    if (!canRefine) return <></>;
    return (
        <div className={styles.container}>
            <Slider.Root
                className={styles.root}
                min={min}
                max={max}
                value={value}
                onValueChange={handleValueChange}
                onValueCommit={handleRefine}
                disabled={!canRefine}
                minStepsBetweenThumbs={1}
            >
                <Slider.Track className={styles.track}>
                    <Slider.Range className={styles.range} />
                </Slider.Track>
                <Slider.Thumb className={styles.thumb} />
                <Slider.Thumb className={styles.thumb} />
            </Slider.Root>
        </div>
    );
};
